import React from 'react';
import { useDispatch } from 'react-redux';
import Content from './PanelSites/Content';
import Header from './PanelSites/Header';
import { autoLogin } from '../store/login';

function Panel() {
  const dispatch = useDispatch();

  React.useEffect(() => {
    dispatch(autoLogin());
    console.log('ver');
  }, [dispatch]);

  return (
    <div className="container">
      <Header />
      <Content />
    </div>
  );
}

export default Panel;
